const Link = ({ url = "", text = "" }) => (
  <a target="_blank" rel="noreferrer" href={url} className="text-[#3077FF]">
    {text}
  </a>
);

export default Link;
